import React, { useState, useEffect } from 'react';
import { useRouterHooks } from '@utils/routerHooks';
import Spinner from '@components/Spinner';
import LessonService from '@services/lessonService';

interface TParams {
  lessonId?: number;
}

export default function withLesson(WrappedComponent: any, lessonId?: number) {
  return () => {
    const { match } = useRouterHooks<TParams>();
    const [loading, setLoading] = useState(false);
    const [lesson, setLesson] = useState<Lesson>();

    const id = lessonId || match.params.lessonId || 0;

    useEffect(() => {
      if (!id) {
        return;
      }

      if (!loading && (!lesson || (lesson && lesson.id !== Number(match.params.lessonId)))) {
        setLoading(true);
        LessonService.getOne(id).then((c: any) => {
          setLesson(c);
          setLoading(false);
        });
      }
    }, [lesson, id, loading, match.params.lessonId]);

    if (!id) {
      return <Spinner />;
    }

    if (loading) {
      return <Spinner />;
    }

    if (!lesson) {
      return null;
    }

    return <WrappedComponent lesson={lesson} />;
  };
}
